<c-container fluid>
  <c-row class="justify-content-center mt-4">
    <c-col xs="12" lg="10">
      <c-card>
        <c-card-header>
          <strong>{{ 'kyc_sumsub_page_title' | translate }}</strong>
        </c-card-header>

        <c-card-body class="p-4">
          <!-- Loading State -->
          @if (loading()) {
            <div class="text-center py-5">
              <c-spinner color="primary" class="mb-3"></c-spinner>
              <p class="text-muted mb-0">{{ 'kyc_sumsub_loading' | translate }}</p>
            </div>
          }

          <!-- Error State -->
          @if (error() && !loading()) {
            <c-alert color="danger">
              {{ error() }}
            </c-alert>
          }

          <!-- Submitted Confirmation -->
          @if (submitted() && !error()) {
            <c-alert color="success">
              <strong>✅</strong> {{ 'kyc_sumsub_submitted' | translate }}
            </c-alert>
          }

          <!-- Sumsub WebSDK Container -->
          <!-- @if (!loading() && !error() && !submitted()) { -->
            <div
              id="sumsub-websdk-container"
              style="min-height: 500px;"
            ></div>
          <!-- } -->
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</c-container>